enum CartItemChangeType {
  Add = 'add',
  Update = 'update',
  Remove = 'remove',
}

export default CartItemChangeType;
